import React from "react";
import { Box } from "grommet";

const SessionDataTable = ({ podSession }) => {
  const generateTableData = () => {
    if (!podSession) return [];

    const sessionLink = `https://www.monitoredu.live/pod-session?id=${podSession.id}`;
    const date = new Date().toLocaleString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    // data string should have all key value pairs from podSession and podSession.fields
    // and should be in the format of key: value
    const dataString = Object.entries(podSession)
      .filter(
        ([key]) =>
          key !== "id" &&
          key !== "createdAt" &&
          key !== "idPictureUrlPath" &&
          key !== "updatedAt" &&
          key !== "selfiePictureUrlPath" &&
          key !== "iconfirm" &&
          key !== "timer" &&
          key !== "video" &&
          key !== "type" &&
          key !== "__typename" &&
          key !== "video" &&
          key !== "typeA" &&
          key !== "iConfirm" &&
          key !== "googleMeetLink" &&
          key !== "verified_by" &&
          key !== "notes"
      )
      .map(([key, value]) => {
        if (key === "fields") {
          return value.map((item) => `${item.key}: ${item.value}`).join(",\n");
        }
        return `${key}: ${value}`;
      })
      .join(",\n");

    return [
      {
        sessionId: podSession.id,
        sessionLink: sessionLink,
        date: date,
        proctor: "",
        client: podSession.organizationName || "",
        flag: "",
        student: podSession.testerName || "",
        receiptNumber:
          podSession.fields.find((field) => field.key === "receipt")?.value ||
          "",
        didCheckId: "",
        didCheckRoom: "",
        didCheckWristsEars: "",
        email: podSession.testerEmail || "",
        phone: podSession.testerPhone || "",
        instructorLastName:
          podSession.fields.find((field) => field.key === "instructor")
            ?.value || "",
        examName:
          podSession.fields.find((field) => field.key === "exam")?.value || "",
        data: dataString,
        startTime: "",
        endTime: "",
        didConfirmSubmission: "",
        primaryProctorNotes: "",
        primaryProctorLink: "",
        secondaryProctorLink: "",
        secondaryProctorName: "",
        sessionId2: podSession.id,
        sessionLink2: sessionLink,
      },
    ];
  };

  const tableHeaders = [
    "Session ID",
    "Session Link",
    "Date",
    "Proctor",
    "Client",
    "Flag",
    "Student",
    "Receipt #",
    "Did you check ID",
    "Did you check the room",
    "Did you check wrists, ears etc",
    "Email",
    "Phone",
    "Instructor Last Name",
    "Exam Name",
    "Data",
    "Start Time",
    "End Time",
    "Did you confirm submission",
    "Primary Proctor Notes (materials used, issues)",
    "Primary Proctor link",
    "Secondary Proctor Link",
    "Secondary Proctor Name",
    "session-id",
    "session-link",
  ];

  return (
    <Box overflow="auto" width="100%">
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          border: "1px solid #ddd",
          fontSize: "14px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <thead>
          <tr>
            {tableHeaders.map((header, index) => (
              <th
                key={index}
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "left",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {generateTableData().map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.sessionId}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.sessionLink}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.date}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.proctor}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.client}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.flag}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.student}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.receiptNumber}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.didCheckId}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.didCheckRoom}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.didCheckWristsEars}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.email}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.phone}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.instructorLastName}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.examName}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.data}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.startTime}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.endTime}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.didConfirmSubmission}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.primaryProctorNotes}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.primaryProctorLink}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.secondaryProctorLink}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.secondaryProctorName}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.sessionId2}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {row.sessionLink2}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default SessionDataTable;
